import * as React from "react";

export const ProductTags = ({ product }) => {

  const badges = product?.tags;
  const bestSellerBadge = badges?.find((badge) =>
    badge.startsWith("new arrivals"),
  )
    ? "NEW ARRIVAL"
    : null;
  const additionalBadge = badges
    .find((badge) => badge.startsWith("additional_badge|"))
    ?.split("|")[1];

  return (
    <div className={"absolute top-0 left-0 m-[4px] flex flex-col"}>
      {bestSellerBadge && (
        <p
          className={
            "h6 font-semibold text-[12px] text-center py-[17px] px-[17px] flex w-fit uppercase"
          }
        >
          {bestSellerBadge}
        </p>
      )}
      {additionalBadge && (
        <p
          className={
            "b4 font-semibold text-[12px] text-center text-white bg-black rounded-[30px] border border-black py-[4px] px-[8px] flex w-fit uppercase"
          }
        >
          {additionalBadge}
        </p>
      )}
    </div>
  );
};
